const buildFormData = (
    data: { [key: string]: unknown } | unknown,
    formData?: FormData,
    parentKey?: string,
): FormData => {
    const fd = formData || new FormData();

    if (
        data &&
        typeof data === 'object' &&
        !(data instanceof Date) &&
        !(data instanceof File) &&
        (!(data instanceof Blob) || typeof data !== 'string')
    ) {
        Object.keys(data).forEach((key: string) => {
            buildFormData(
                //@ts-ignore
                data[key],
                fd,
                parentKey ? `${parentKey}[${key}]` : key,
            );
        });
    } else {
        const value = data == null ? '' : data;
        if (parentKey) {
            //@ts-ignore
            fd.append(parentKey, value);
        }
    }
    return fd;
};

export { buildFormData };
